import { Link } from "react-router-dom";

export default function Logo({ to = "/", className = "", onClick, imgClassName = "h-10 sm:h-11" }) {
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`inline-flex items-center ${className}`}
      data-testid="vora-logo"
      aria-label="Vvvoraa home"
    >
      <img
        src="/vvvoraa-logo.png"
        alt="Vvvoraa"
        className={`${imgClassName} w-auto object-contain select-none logo-3d`}
        draggable="false"
      />
    </Link>
  );
}
